export default "__VITE_ASSET__CnNsOUBT__"